import { Children, isValidElement, ReactNode } from 'react';

export function extractChildRoutes(children: ReactNode): string[] {
  const routes: string[] = [];

  Children.forEach(children, (child) => {
    if (!isValidElement(child)) return;

    const props = child.props as Record<string, unknown>;

    if (typeof props.to === 'string' && props.to) {
      routes.push(props.to);
    }

    if (props.children) {
      routes.push(...extractChildRoutes(props.children as ReactNode));
    }
  });

  return routes;
}
